import React, { Component } from 'react'
import Table from './Table'
export default class CustomerTags extends Component {
  render() {
    return <Table {...this.props} />
  }
}
